import { render, staticRenderFns } from "./RelationshipRefusalStrip.vue?vue&type=template&id=b22bfe92&scoped=true"
import script from "./RelationshipRefusalStrip.vue?vue&type=script&lang=js"
export * from "./RelationshipRefusalStrip.vue?vue&type=script&lang=js"
import style0 from "./RelationshipRefusalStrip.vue?vue&type=style&index=0&id=b22bfe92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22bfe92",
  null
  
)

export default component.exports